import { connect } from 'react-redux';
import {
  getPiecesList,
  changePiecesPlant,
  changePiecesStatus,
  getStatusesList
} from '../../../store/actions/admin';
import PieceAdmin from './PieceAdmin';

const mapStateToProps = ({
  responsiblePersonReducer,
  stockReducer,
  userReducer,
  tabsReducer,
  incomingReducer,
  adminReducer
}) => ({
  responsiblePersonReducer,
  stockReducer,
  userReducer,
  tabsReducer,
  incomingReducer,
  adminReducer
});
const mapDispatchToProps = {
  getPiecesList,
  changePiecesPlant,
  changePiecesStatus,
  getStatusesList
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PieceAdmin);
